import { Desert } from "../mechanics/location/Desert";
import { Dungeon } from "../mechanics/location/Dungeon";
import { Forest } from "../mechanics/location/Forest";
import { Location } from "../mechanics/location/Location";
import { backgrounds } from "../tempDB"
import { bossStats, mageStats, rogueStats, warriorStats } from "../mechanics/CreatingMechanic";

export class LocationsController {
    private locations: Location[][]
    private locationsIndex: number
    private static instance: LocationsController

    private constructor() {
        this.locations = []
        this.locationsIndex = 0

        this.setLocations()
    }

    getLocations() {
        return this.locations
    }

    getIndex() {
        return this.locationsIndex
    }

    incIndex() {
        this.locationsIndex++
    }

    decIndex() {
        this.locationsIndex--
    }

    getLocationsSet() {
        return this.locations[this.locationsIndex]
    }

    setLocations() {
        const newSet: Location[] = [
            new Forest({
                background: backgrounds[0],
                isCompleted: false,
                name: "forest",
                maxLevels: 10,
                passsedLevels: 0,
                difficulty: "easy",
                index: 0,
                initEnemies: [warriorStats, rogueStats, mageStats],
                boss: bossStats
            }),
            new Desert({
                background: backgrounds[1],
                isCompleted: false,
                name: "desert",
                maxLevels: 10,
                passsedLevels: 0,
                difficulty: "medium",
                index: 1,
                initEnemies: [warriorStats, rogueStats, mageStats],
                boss: bossStats
            }),
            new Dungeon({
                background: backgrounds[2],
                isCompleted: false,
                name: "dungeon",
                maxLevels: 10,
                passsedLevels: 0,
                difficulty: "high",
                index: 2,
                initEnemies: [warriorStats, rogueStats, mageStats],
                boss: bossStats
            }),
            new Forest({
                background: backgrounds[0],
                isCompleted: false,
                name: "forest",
                maxLevels: 10,
                passsedLevels: 0,
                difficulty: "easy",
                index: 3,
                initEnemies: [warriorStats, rogueStats, mageStats],
                boss: bossStats
            }),
            new Desert({
                background: backgrounds[1],
                isCompleted: false,
                name: "desert",
                maxLevels: 10,
                passsedLevels: 0,
                difficulty: "medium",
                index: 4,
                initEnemies: [warriorStats, rogueStats, mageStats],
                boss: bossStats
            }),
            new Dungeon({
                background: backgrounds[2],
                isCompleted: false,
                name: "dungeon",
                maxLevels: 10,
                passsedLevels: 0,
                difficulty: "high",
                index: 5,
                initEnemies: [warriorStats, rogueStats, mageStats],
                boss: bossStats
            }),
        ]

        this.locations.push(newSet)
    }

    resetLocations() {
        this.locations = []
        this.locationsIndex = 0

        this.setLocations()
    }

    getEnemiesArr(index: number) {
        return this.getLocationsSet()[index].createEnemyArr(this.locationsIndex)
    }

    public static getInstance() {
        if (!LocationsController.instance)
            LocationsController.instance = new LocationsController()

        return LocationsController.instance
    }
}